import { render, staticRenderFns } from "./quotation3.vue?vue&type=template&id=18b876c1&scoped=true&"
import script from "./quotation3.vue?vue&type=script&lang=js&"
export * from "./quotation3.vue?vue&type=script&lang=js&"
import style0 from "./quotation3.vue?vue&type=style&index=0&id=18b876c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b876c1",
  null
  
)

export default component.exports